"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBarDropdown = TopBarDropdown;
var _react = _interopRequireDefault(require("react"));
var _Dropdown = require("b2b-components/theme/components/Dropdown");
var _key = require("b2b-components/utils/key");
function TopBarDropdown(_ref) {
  let {
    linksGroups,
    onLinkClick
  } = _ref;
  if (!Array.isArray(linksGroups) || !linksGroups.length) {
    return null;
  }
  const handleLinkClick = href => event => {
    onLinkClick(href, event);
    event.preventDefault();
  };
  const renderGroup = _ref2 => {
    let {
      name,
      links
    } = _ref2;
    if (!Array.isArray(links) || !links.length) {
      return null;
    }
    if (links.length === 1) {
      const link = links[0];
      return /*#__PURE__*/_react.default.createElement("li", {
        key: (0, _key.createKey)(link.title)
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: link.href,
        className: "cds-TopBar-Link",
        onClick: handleLinkClick(link.href)
      }, link.title));
    }
    const dropdownLinks = links.map(_ref3 => {
      let {
        title,
        href
      } = _ref3;
      return {
        onClick: () => {
          onLinkClick(href);
        },
        title
      };
    });
    return /*#__PURE__*/_react.default.createElement("li", {
      key: (0, _key.createKey)(name)
    }, /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, {
      links: dropdownLinks,
      isHoverable: true,
      className: "cds-TopBar-DropDropdown",
      tooltipWrapperClassName: "cds-TopBar-Tooltip",
      togglerProps: {
        label: name,
        className: 'cds-TopBar-Dashboard-Toggler'
      }
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-TopBar-Section cds-TopBar-Section--NavLinks"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "cds-List cds-List--Unstyled cds-List--Inline"
  }, linksGroups.map(renderGroup)));
}
//# sourceMappingURL=TopBarDropdown.js.map